import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { SessionService } from './shared/services/session.service';
import { EfsApiService } from './shared/services/efs-api.service';
import { DataSharingService } from './shared/services/data-sharing.service';
import { ApiErrorHandlingService } from '@efsShared/services/api-error-handling.service';
import { PermissionHandlingService } from '@efsShared/services/permission-handling.service';
import { PopupWindowService } from '@EfsServices/popup-window.service';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MaterialModule } from './material.module';

import { CookieService } from 'ngx-cookie-service';

import { InitialPageComponent } from './initial-page/initial-page.component';
import { SetupPageComponent } from './setup-page/setup-page.component';
import { NationalSetupPageComponent } from './national-setup-page/national-setup-page.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ReusableTableComponent } from './reusable-table/reusable-table.component';
import { GenericPopupComponent } from '@EfsReusable/generic-popup/generic-popup.component';
import { PopupWithUserinput  } from '@EfsReusable/generic-popup/popup-with-userinput';
import { CommonListCorpsComponent } from './shared/common-components/common-list-corps/common-list-corps.component';
import { CommonListNationalCorpsComponent } from './shared/common-components/common-list-national-corps/common-list-national-corps.component';
import { RuleSetupListCorpsComponent } from './shared/common-components/common-list-corps/ruleSetup-list-corps.component';
import { SessionTimerService } from '@EfsServices/session-timer.service';
import { FactoryGuiComponent } from './factory-gui/factory-gui.component';
import { HelpPageComponent } from './shared/common-components/help-page/help-page.component';
import { SpecialLinksPageComponent } from '@efsShared/common-components/special-links-page/special-links-page.component';
import { SingleUserSetupICCComponent } from './single-user-setup-icc/single-user-setup-icc.component';
import { MailerIdSetupComponent } from './mailer-id-setup/mailer-id-setup.component';
import { ParameterEntryComponent } from './parameter-entry/parameter-entry.component';
import { PerfMeasurementsComponent } from './perf-measurements/perf-measurements.component';
import { CorpProfileSetupComponent } from './corp-profile-setup/corp-profile-setup.component';

@NgModule({
    declarations: [
        AppComponent,
        InitialPageComponent,
        SetupPageComponent,
        NationalSetupPageComponent,
        BreadcrumbComponent,
        NotFoundComponent,
        ReusableTableComponent,
        GenericPopupComponent,
        PopupWithUserinput,
        CommonListCorpsComponent,
        CommonListNationalCorpsComponent,
        RuleSetupListCorpsComponent,
        FactoryGuiComponent,
        HelpPageComponent,
        SpecialLinksPageComponent,
        SingleUserSetupICCComponent,
        MailerIdSetupComponent,
        ParameterEntryComponent,
        PerfMeasurementsComponent,
        CorpProfileSetupComponent,
    ],
    imports: [
        BrowserAnimationsModule,
        CommonModule,
        MaterialModule,
        AppRoutingModule,
    ],
    providers: [SessionService,
        EfsApiService,
        CookieService,
        DataSharingService,
        ApiErrorHandlingService,
        PermissionHandlingService,
        SessionTimerService,
        PopupWindowService,
        DatePipe,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
